import type { CurrencyAmount } from '@omnipresentgroup/design-system';

import type { Address } from '../common';
import type { ContractorDocument } from '../contractorDocuments';

export enum ContractorInvoiceStateEnum {
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  PAID = 'PAID',
  REJECTED = 'REJECTED',
}

export enum PermittedInvoiceCurrenciesEnum {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
}

export type ContractorInvoice = {
  id: string;
  state: ContractorInvoiceStateEnum;
  contractor: {
    id: string;
    name: string;
  };
  client: {
    id: string;
    name: string;
  };
  amount: string;
  currency: PermittedInvoiceCurrenciesEnum;
  dueDate: string;
  description: string;
  raisedAt: string;
  paidAt?: string;
  overdueBy?: string;
  invoiceRef: string;
  attachments?: ContractorDocument[];
  paymentId?: string;
  billingCurrency: PermittedInvoiceCurrenciesEnum;
};

export type ContractorInvoicePaymentDetails = {
  ownerName: string;
  ownerAddress: Address;
  iban: string;
  bic: string;
  reference: string;
  total: CurrencyAmount;
};
